var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentLogo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_9955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12.0624C20 14.7954 17.7888 17.0066 15.0558 17.0066C13.9021 17.0066 12.8446 16.6083 12.0068 15.9491C13.1605 15.0426 13.8884 13.6418 13.8884 12.0624C13.8884 10.483 13.1467 9.08211 12.0068 8.17568C12.8446 7.51645 13.9021 7.11816 15.0558 7.11816C17.7888 7.11816 20 9.34306 20 12.0624Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0069 8.17578C12.0069 8.17578 12.0069 8.17578 12.0069 8.17578C13.1468 9.08222 13.8884 10.4831 13.8884 12.0625C13.8884 13.6419 13.1605 15.0427 12.0069 15.9492L11.9931 15.9492C10.8532 15.0565 10.1116 13.6419 10.1116 12.0625C10.1116 10.4831 10.8532 9.08225 11.9931 8.17581C11.9931 8.1758 11.9931 8.17582 11.9931 8.17581L12.0069 8.17578Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1116 12.0624C10.1116 10.483 10.8532 9.08211 11.9931 8.17568C11.1554 7.51645 10.0979 7.11816 8.94421 7.11816C6.21116 7.11816 4 9.32932 4 12.0624C4 14.7954 6.21116 17.0066 8.94421 17.0066C10.0979 17.0066 11.1554 16.6083 11.9931 15.9491C10.8532 15.0564 10.1116 13.6418 10.1116 12.0624Z",
    fill: "#EB001B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_9955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9.88842,
    fill: "white",
    transform: "translate(4 7.11816)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLogo3);
export default __webpack_public_path__ + "static/media/payment-logo-3.87421d0a560cfaa4e3feb3ea529bcf4c.svg";
export { ForwardRef as ReactComponent };